import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

const ZoomContextProvider = lazy(() => import('../ZoomContext/ZoomContext'));
const CalendarNotificationContextProvider = lazy(() => import('../CalendarNotificationContext/CalendarNotificationContext'));
const MessageServicesContainer = lazy(() => import('../../features/message/containers/MessageServicesContainer/MessageServicesContainer'));

const BillerPortalContainer = () => (
  <CalendarNotificationContextProvider>
    <ZoomContextProvider>
      <MessageServicesContainer>
        <Outlet />
      </MessageServicesContainer>
    </ZoomContextProvider>
  </CalendarNotificationContextProvider>
);

export default BillerPortalContainer;
